import { Language } from '../models/enums/language.enum';

// Mirrors LocalizationState.activeLanguage for plain functions and pure pipes, like moment.locale() does for moment.
let activeLocale: string = Language.English;
const COLLATOR_OPTIONS: Intl.CollatorOptions = { sensitivity: 'accent' };
let collator = new Intl.Collator(activeLocale, COLLATOR_OPTIONS);

export function setActiveLocale(locale: string): void {
  activeLocale = locale;
  collator = new Intl.Collator(locale, COLLATOR_OPTIONS);
}

export function getActiveLocale(): string {
  return activeLocale;
}

export function compareLocale(first: string | null | undefined, second: string | null | undefined): number {
  return collator.compare(first ?? '', second ?? '');
}

export function sortByLocale<T>(items: T[] | null | undefined, selector: (item: T) => string, direction: 'asc' | 'desc' = 'asc'): T[] {
  const compare = (first: T, second: T): number => compareLocale(selector(first), selector(second));
  return [...(items ?? [])].sort(direction === 'desc' ? (first, second): number => compare(second, first) : compare);
}
